module.exports = __webpack_public_path__ + "img/psychiatry.bb7ab278.png";